import { Injectable } from '@angular/core';
import { SettingsKey } from 'src/app/core/store/settings-config.keys';
import { SettingsService } from '../data-service/settings.service';
import { EnableAttachment } from '../enums/enable-attachment.enum';
import { CurrentOrderService } from './current-order.service';
import { AttachDocumentService } from '../data-service/attach-document.service';
import { AttachDocument } from '../models/attach-document';
import { Observable } from 'rxjs';
import { File } from '../models/attach-document/file.model';
import { v4 as uuidv4 } from 'uuid';
import { AppConfigService } from 'src/app/core/app-config/app-config.service';
import { LinkedObjectType } from '../enums/linked-object-type.enum';

@Injectable({
  providedIn: 'root'
})
export class AttachDocumentHelperService {

  constructor(
    private settingsService: SettingsService,
    private currentOrderService: CurrentOrderService,
    private attachDocumentService: AttachDocumentService,
    private appConfigService: AppConfigService) { }

  public async getAttachmentLevel(): Promise<EnableAttachment> {
    const displaySampleAttachment = (await this.settingsService
      .getSettingValue(SettingsKey.DisplaySampleAttachment)).toLowerCase() === 'true';

    if (displaySampleAttachment && this.currentOrderService.currentOrder.orderTemplate.enableAttachment !== EnableAttachment.None) {
      return this.currentOrderService.currentOrder.orderTemplate.enableAttachment === EnableAttachment.SampleLevel ?
        EnableAttachment.SampleLevel : EnableAttachment.OrderLevel;
    }
  }

  public getIcon(fileName: string) {
    const ext = fileName?.match(/\.[0-9a-z]+$/i)[0].toLowerCase();
    switch (ext) {
      case '.doc':
      case '.docx':
        return './assets/images/doc-icon.png';
      case '.pdf':
        return './assets/images/1025-pdf.svg';
      case '.txt':
        return './assets/images/text-icon.png';
      case '.xls':
      case '.xlsx':
        return './assets/images/excel-icon.png';
      case '.jpg':
      case '.jpeg':
      case '.png':
        return './assets/images/image-icon.png';
    }
  }

  private GetInternalFileName(name: string, sampleReference: string, isSampleLevel = true): string {
      let fileName = 'go/' + this.appConfigService.configuration.instanceName +
        '/' + this.currentOrderService.currentOrder.account.code + '/' +
        this.currentOrderService.currentOrder.OrderReference + '/';
      if (isSampleLevel) {
        fileName = fileName + sampleReference + '/';
      }
      return fileName = fileName + uuidv4() + '-' + name;
  }

  public async cloneAttachmentsForOrder(replicatedFromOrderReference: string, newOrderReference: string, newSampleCodes: string[]) {
    try {
      const data = await this.attachDocumentService.getAttachments(replicatedFromOrderReference).toPromise();
      const sourceInternalNames = data.map(a => a.internalFileName);
      const documentsWithCode: { documents: AttachDocument[]; sampleCode: string }[] = [];
      const sourceSampleCodes = Array.from(new Set(data.map(a => a.sampleCode).sort()));
      newSampleCodes = newSampleCodes.sort();
      data.forEach(doc => {
        const attachDoc = new AttachDocument();
        attachDoc.name = doc.fileName;
        const newSampleCode = newSampleCodes[sourceSampleCodes.indexOf(doc.sampleCode)];
        attachDoc.internalFileName = this.GetInternalFileName(doc.fileName, newSampleCode, newSampleCode ? true : false);
        documentsWithCode.push({ documents: [attachDoc], sampleCode: doc.linkedObjectType === LinkedObjectType.Sample ? newSampleCode : '' });
      });

      this.attachDocumentService.copyDocuments(
        newOrderReference,
        sourceInternalNames,
        documentsWithCode,
        replicatedFromOrderReference
      ).toPromise();
    } catch (exception) {
      console.error('Error fetching/cloning attachments: ', exception);
      return new Observable<File[]>();
    }
  }
}
